module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('scroller', {
    attrs: {
      "lock-x": "",
      "height": _vm.heightData,
      "scrollbarY": ""
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('panel', {
    staticClass: "movieList",
    attrs: {
      "header": _vm.header,
      "list": _vm.dataList,
      "type": "5"
    },
    on: {
      "on-img-error": _vm.onImgError
    }
  }), _vm._v(" "), (_vm.isLoadMoreShow) ? _c('load-more', {
    attrs: {
      "tip": "loading"
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30cd0ddc"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/US_box.vue
// module id = 196
// module chunks = 1